import { render, staticRenderFns } from "./TerminalSelector.vue?vue&type=template&id=63b96580&scoped=true"
import script from "./TerminalSelector.vue?vue&type=script&lang=js"
export * from "./TerminalSelector.vue?vue&type=script&lang=js"
import style0 from "./TerminalSelector.vue?vue&type=style&index=0&id=63b96580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b96580",
  null
  
)

export default component.exports